import api from "../services/api";
import globalToast from "../components/common/globalToast";

const service_path = '/clasp-types.php';

export function getClaspTypes() {

    const response = api.get(service_path);

    return response;
};

export function getClaspTypeDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createClaspType(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateClaspType(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteClaspType(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Tipo de fecho deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse tipo de fecho!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};